import React from 'react';
import {Link} from 'react-router';

const ExportLink = () => {
  return (
    <span>
      {" | "}
      <Link to="/export" activeClassName="active">Export</Link>
    </span>
  );
};

export default ExportLink;



// WEBPACK FOOTER //
// ./src/components/common/ExportLink.js